// src/locales/si/sidebar.js
export const sidebar = {
    collapseTooltip: "පැති තීරුව හකුළන්න",
    expandTooltip: "පැති තීරුව විහිදන්න",
    groupOverview: "දළ විශ්ලේෂණය",
    groupSales: "විකුණුම් සහ ඇණවුම්",
    groupLogistics: "සැපයුම් සේවා",
    groupCatalog: "නිෂ්පාදන සහ ගබඩා",
    groupFinance: "මූල්‍ය සහ වාර්තා",
    groupPeople: "සේවකයින්",
    groupSystem: "පද්ධතිය",
    allOrders: "සියලුම ඔන්ලයින් ඇණවුම්",
    createOrder: "ඔන්ලයින් ඇණවුමක් සාදන්න",
    storePickupOrders: "Store Pickup ඇණවුම්",
    bulkOrderCreate: "තොග ඇණවුම් සාදන්න",
    orderAssignment: "ඇණවුම් පැවරීම",
    callCenter: "ඇමතුම් මධ්යස්ථානය",
    assignmentRules: "පැවරීම් නීති",
    manualAssignment: "අතින් පැවරීම",
    myWorkQueue: "මගේ වැඩ පෝලිම",
    packingBatches: "ඇසුරුම් කණ්ඩායම්",
    paymentVerification: "ගෙවීම් සත්‍යාපනය",
    dispatchSingleOrder: "තනි ඇණවුමක් යවන්න",
    courierUploadFormat: "කුරියර් උඩුගත කිරීමේ ආකෘතිය",
    courierInvoices: "කුරියර් ඉන්වොයිස",
    allInvoices: "සියලුම ඉන්වොයිස",
    createInvoice: "ඉන්වොයිසයක් සාදන්න",
    returnBatches: "ආපසු ලබා දීමේ කණ්ඩායම්",
    allReturnBatches: "සියලුම ආපසු ලබා දීමේ කණ්ඩායම්",
    processReturns: "ආපසු ලබා දීම් ක්‍රියාත්මක කරන්න",
    deliveryFollowUp: "ප්‍රවාහන පසු විචාරණය",
    settlementBatches: "සමථයකරණ කණ්ඩායම්",
    returns: "ආපසු ලබා දීම්",
    allProducts: "සියලුම නිෂ්පාදන",
    addProduct: "නිෂ්පාදනයක් එකතු කරන්න",
    categories: "වර්ග",
    attributes: "ගුණාංග",
    brands: "වෙළඳ නාම",
    tags: "ටැග්",
    stockOverview: "ගබඩා විමසුම",
    purchaseOrders: "මිලදී ගැනීම් ඇණවුම්",
    stockAdjustments: "ගබඩා සකස්කිරීම්",
    stockTransfers: "ගබඩා මාරු කිරීම්",
    warehouses: "ගබඩා",
    suppliers: "සැපයුම්කරුවන්",
    goodsReceivedNotes: "භාණ්ඩ ලැබීමේ සටහන්",
    returnsToVendor: "සැපයුම්කරුට ආපසු භාණ්ඩ",
    debitNotes: "ණය සටහන්",
    payables: "ගෙවිය යුතු මුදල්",
    expenses: "වියදම්",
    messageCenter: "මැසේජ් සෙන්ටරය",
    messageCenterShifts: "මුරප්පාර",
    messageCenterShiftTypes: "මුර වර්ග",
    messageCenterCommission: "කොමිසම",
    messageCenterStaffCommission: "කාර්ය මණ්ඩල කොමිසම",
    messageCenterShiftLeaderCommission: "මුර නායක කොමිසම",
    callCenterShifts: "මුරප්පාර",
    callCenterCommission: "හරස් විකුණුම් කොමිසම",
    callCenterStaffCommission: "කාර්ය මණ්ඩල කොමිසම",
    allUsers: "සියලුම පරිශීලකයින්",
    addUser: "පරිශීලකයෙකු එකතු කරන්න",
    userRoles: "පරිශීලක භූමිකාවන්",
    createRole: "භූමිකාවක් සාදන්න",
    allShops: "සියලුම වෙළඳසැල්",
    addShop: "වෙළඳසැලක් එකතු කරන්න",
    salesReports: "විකුණුම් වාර්තා",
    productWiseSales: "Product Wise Sales",
    productWiseReturns: "Product Wise Returns",
    profitAndLoss: "ලාභ සහ අලාභ",
    courierPerformance: "කුරියර් කාර්ය සාධනය",
    messageCenterSummary: "පණිවිඩ මධ්‍යස්ථාන සාරාංශය",
    callCenterSummary: "ඇමතුම් මධ්‍යස්ථාන සාරාංශය",
    inventoryReports: "ඉන්වෙන්ටරි වාර්තා",
    analytics: "විශ්ලේෂණ",
    courierManagement: "කුරියර් කළමනාකරණය",
    courierAssignmentRules: "කුරියර් පැවරීම් නීති",
    phoneBlacklist: "දුරකථන කළු ලැයිස්තුව",

    woocommerceSync: "WooCommerce ඇණවුම් සමමුහුර්තය",
    openTerminal: "Open Terminal",
    posOrders: "POS ඇණවුම්",
    posCustomers: "POS ගනුදෙනුකරුවන්",
    posSessions: "භාර ලිපිකරු සැසි",
    posSettings: "POS සැකසුම්",
    posPaymentMethods: "ගෙවීම් ක්‍රම",
    offlineSales: "දුරස්ථ විකුණුම්",
    offlineSalesOrders: "දුරස්ථ විකුණුම් ඇණවුම්",
    createOfflineSalesOrder: "දුරස්ථ විකුණුම් ඇණවුමක් සාදන්න",
    offlineSalesCustomers: "ගනුදෙනුකරුවන්",
    offlineSalesSessions: "මුදල් අයකැමි සැසි",
    offlineSalesReceivables: "ලැබිය යුතු මුදල්",
    offlineSalesCustomerPayments: "ගනුදෙනුකරු ගෙවීම්",
    offlineSalesCheques: "චෙක්පත්",
    offlineSalesQuotations: "මිල ගණන්",
    offlineSalesDeliveryNotes: "බෙදාහැරීමේ සටහන්",
    offlineSalesReturnNotes: "ආපසු ලබාදීමේ සටහන්",
    offlineSalesCreditNotes: "ණය සටහන්",
    offlineSalesSettings: "සැකසුම්",
    offlineSalesPaymentMethods: "ගෙවීම් ක්‍රම",
    offlineSalesPacking: "කුරියර් ඇසුරුම් කිරීම",
    version: "අනුවාදය 1.0.0"
}